module.exports = __webpack_public_path__ + "static/img/banner.7ec81caa.png";